// No iPhone, um ficheiro escolhido na fototeca pode deixar de poder ser lido quando o campo muda (por exemplo, quando
// fica desativado durante o envio): o Safari envia a parte do ficheiro vazia e o servidor responde «file: Field required».
// Lê-se logo para a memória e envia-se essa cópia. Um ficheiro vazio (foto só no iCloud) dá uma mensagem clara.
const EXTENSAO = { "image/jpeg": "jpg", "image/png": "png", "application/pdf": "pdf" };

export async function copiaDoFicheiro(ficheiro) {
  const bytes = await ficheiro.arrayBuffer();
  if (!bytes.byteLength) {
    throw new Error("Não foi possível ler o ficheiro. Se a foto estiver no iCloud, abra-a primeiro na app Fotografias e tente outra vez.");
  }
  const tipo = ficheiro.type || "application/octet-stream";
  const nome = ficheiro.name || `documento.${EXTENSAO[tipo] || "bin"}`;
  return new File([bytes], nome, { type: tipo });
}
